import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-eye_open",
  "use": "icon-eye_open-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-eye_open\"><defs><style></style></defs><path d=\"M512 384a128 128 0 0 0-128 128 128 128 0 0 0 128 128 128 128 0 0 0 128-128 128 128 0 0 0-128-128m0 341.333A213.333 213.333 0 0 1 298.667 512 213.333 213.333 0 0 1 512 298.667 213.333 213.333 0 0 1 725.333 512 213.333 213.333 0 0 1 512 725.333M512 192c-213.333 0-395.52 132.693-469.333 320 73.813 187.307 256 320 469.333 320s395.52-132.693 469.333-320C907.52 324.693 725.333 192 512 192z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol